import { render } from "./VectorSharedItem.vue?vue&type=template&id=2c7f9dee&scoped=true"
import script from "./VectorSharedItem.vue?vue&type=script&lang=js"
export * from "./VectorSharedItem.vue?vue&type=script&lang=js"

import "./VectorSharedItem.vue?vue&type=style&index=0&id=2c7f9dee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7f9dee"]])

export default __exports__